import { template as template_eb911308670e4fcea445989cef06abfd } from "@ember/template-compiler";
import EmberGrid from 'eflex/components/ember-grid';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { isEmpty } from '@ember/utils';
import { join, sortBy } from '@eflexsystems/ember-composable-helpers';
import { not } from 'ember-truth-helpers';
import { t } from 'ember-intl';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import BsTooltip from 'eflex/components/bs-tooltip';
import MultipieceIcon from 'eflex/components/multipiece-icon';
export default template_eb911308670e4fcea445989cef06abfd(`
{{#if (not (isEmpty @model))}}
  <EmberGrid
    class="jobs-grid"
    @data={{@model}}
    @fetch={{@fetch}}
  >
    <thead>
      <tr>
        {{#unless @isComplete}}
          <th></th>
        {{/unless}}
        <th>
          {{t "job"}}
        </th>
        <th>
          {{t "kinetic.assembly"}}
        </th>
        <th>
          {{t "kinetic.operation"}}
        </th>
        <th>
          {{t "kinetic.part"}}
        </th>
        <th>
          {{t "kinetic.revision"}}
        </th>
        <th>
          {{t "quantity"}}
        </th>
        {{#if @isComplete}}
          <th>
            {{t "kinetic.good"}}
          </th>
          <th>
            {{t "kinetic.rejected"}}
          </th>
          <th>
            {{t "kinetic.scrapped"}}
          </th>
        {{/if}}
      </tr>
    </thead>
    <tbody>
      {{#each (sortBy "job.jobNumber" "assembly.assemblySequence" "sequence" @model) as |operation|}}
        <tr
          class="ember-grid-action-row operation-row"
          {{on "click" (fn @onOperationSelected operation)}}
        >
          {{#unless @isComplete}}
            <td class="app-operation-icon d-flex align-items-center flex-column">
              {{#if (not (isEmpty (operation.warnings))) }}
                <div class="icon-message help" title={{join ", " (operation.warnings)}}>
                  <FaIcon @icon="triangle-exclamation" @prefix="fas" class="fa"/>
                </div>
              {{/if}}
            </td>
          {{/unless}}
          <td class="app-operation-job">
            {{operation.job.jobNumber}}
          </td>
          <td class="app-operation-assembly">
            {{operation.assembly.assemblySequence}}
          </td>
          <td class="app-operation-name">
            {{#if operation.operation.isMultipiece}}
              <span class="test-is-multipiece-icon">
                <MultipieceIcon />
                <BsTooltip @placement='right' @triggerEvents="hover">
                  {{t "multipiece"}}
                </BsTooltip>
                &nbsp;
              </span>
            {{/if}}
            {{operation.name}}
          </td>
          <td class="app-part-name">
            {{operation.part.name}}
          </td>
          <td class="app-part-rev-name {{if operation.partRev.isOtf 'fst-italic otf-part-rev'}}">
            {{operation.partRev.name}}
          </td>
          <td class="app-operation-quantity">
            {{operation.quantityCount}}
          </td>
          {{#if @isComplete}}
            <td class="test-app-operation-good">
              {{operation.reportedGoodQuantity}}
            </td>
            <td class="test-app-operation-rejected">
              {{operation.reportedRejectedQuantity}}
            </td>
            <td class="test-app-operation-scrapped">
              {{operation.reportedScrappedQuantity}}
            </td>
          {{/if}}
        </tr>
      {{/each}}
    </tbody>
  </EmberGrid>
{{else}}
  <div class="d-flex align-items-center justify-content-center w-100 h-100 overflow-auto">
    <h6 class="text-gray-500 fw-semibold mb-0">{{@emptyMessage}}</h6>
  </div>
{{/if}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
